import { Typography } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { CheckboxComponent } from '../../inputComponents/CheckboxComponent';
import { FormikContextType, getIn } from 'formik';
import { InputComponent } from '../../inputComponents/InputComponent';
import { ICreatePromotionState } from '../../../types/componentTypes/assignPromo';
import TooltipText from '../../inputComponents/TooltipText';
import { ToolTipPlacement } from '../../../types/componentTypes/tooltip';

const CaptchaCheckerComponent = ({ formik }: { formik: FormikContextType<ICreatePromotionState> }) => {
    const defaultValue = getIn(formik.values, 'tempParams.addCaptcha') || false;
    //temp until secret option is removed
    const defaultSecret = getIn(formik.values, 'tempParams.addCaptchaSecret') || false;

    const [captchaEnabled, setCaptchaEnabled] = useState(defaultValue);
    //temp until secret option is removed
    const [captchaSecretEnabled, setCaptchaSecretEnabled] = useState(defaultSecret);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setCaptchaEnabled(checked);

        if (!checked) {
            formik.setFieldValue('configurationParameters.captchaDetails', undefined);
        } else {
            formik.setFieldValue('configurationParameters.captchaDetails.projectId', 'tccc-martech-recaptcha');
            //temp until secret option is removed
            setCaptchaSecretEnabled(false);
            formik.setFieldValue('tempParams.addCaptchaSecret', false);
        }

        formik.setFieldValue('tempParams.addCaptcha', checked);
    };

    //temp until secret option is removed
    const handleSecretChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setCaptchaSecretEnabled(checked);

         if (checked) {
            setCaptchaEnabled(false);
            formik.setFieldValue('tempParams.addCaptcha', false);
            formik.setFieldValue('configurationParameters.captchaDetails', undefined);
        }

        if (!checked) {
            formik.setFieldValue('configurationParameters.captchaSecret', '');
        }

        formik.setFieldValue('tempParams.addCaptchaSecret', checked);
    };

    return (
        <>
            {!captchaSecretEnabled && (
                <CheckboxComponent
                    fieldName={'tempParams.addCaptcha'}
                    label={<Typography variant='body1'>Add enterprise recaptcha (Optional)</Typography>}
                    customOnChangeHandler={handleChange}
                    customBoxClass='captcha-checkbox'
                    testingId={'captcha-checkbox'}
                />
            )}
            {!captchaEnabled && (
                <CheckboxComponent
                    fieldName={'tempParams.addCaptchaSecret'}
                    label={<Typography variant='body1'>Add captcha secret (Optional)</Typography>}
                    customOnChangeHandler={handleSecretChange}
                    customBoxClass='captcha-checkbox'
                    testingId={'captcha-secret-checkbox'}
                />
            )}
            {captchaEnabled && (
                <>
                <InputComponent
                    formik={formik}
                    inputValue={getIn(formik.values, 'configurationParameters.captchaDetails.projectId')}
                    formikLabel={'configurationParameters.captchaDetails.projectId'}
                    label={
                        <TooltipText
                            text='Google Cloud Project ID'
                            textVariant='body1'
                            tooltip='If you are not using the default project, please contact Promo+ team to provide API key'
                            iconSize='medium'
                            placement={ToolTipPlacement.RightEnd}
                        />
                    }
                    inputClassName='captcha-box'
                    shouldFocusOnElement={true}
                />
                <InputComponent
                    formik={formik}
                    inputValue={getIn(formik.values, 'configurationParameters.captchaDetails.siteKey')}
                    formikLabel={'configurationParameters.captchaDetails.siteKey'}
                    label='Captcha site key'
                    inputClassName='captcha-box'
                    shouldFocusOnElement={true}
                    dataTestId='captcha-site-key-input'
                />
                </>
            )}

            {captchaSecretEnabled && (
                <InputComponent
                    formik={formik}
                    inputValue={getIn(formik.values, 'configurationParameters.captchaSecret')}
                    formikLabel={'configurationParameters.captchaSecret'}
                    label='Captcha secret'
                    inputClassName='captcha-box'
                    shouldFocusOnElement={true}
                />
            )}
        </>
    );
};

export default CaptchaCheckerComponent;
